import { Grid } from '@interstate/components/Grid';
import { BreakPoint } from '@makemydeal/dr-activities-common';
import { MAX_ACTIVITY_CONTAINER_WIDTH_NEW, toRem } from '@makemydeal/dr-dash-components';
import styled from 'styled-components';

export const InterstateDealActivityContainer = styled(Grid)`
    max-width: ${toRem(352)};
    && {
        padding: 40px 16px;
    }

    @media (max-width: ${MAX_ACTIVITY_CONTAINER_WIDTH_NEW}) {
        && {
            display: none;
        }
    }
`;

export const DealWrapper = styled(Grid)`
    @media (min-width: ${BreakPoint.TABLET_PORTRAIT}) {
        max-width: 320px;
        margin-bottom: 16px;
    }
`;

export const DealDashboardContainer = styled.div<{
    applyDealStatusStyles?: boolean;
}>`
    display: flex;
    justify-content: space-between;

    flex-wrap: wrap;
    align-items: center;

    @media (max-width: ${BreakPoint.TABLET_PORTRAIT}) {
        gap: 0.5rem;
    }
`;

export const OfferCommentsWrapper = styled.div`
    display: block;
    margin: 0.5rem 0 0 0;
`;

export const DealCentralContainer = styled.div`
    margin-bottom: 5rem;
`;

export const DealCentralContainerCompact = styled(DealCentralContainer)`
    margin-bottom: 0;
`;
